<app-transaction-create [transactionType]="transactionTypeEnum.INVOICE"></app-transaction-create>
